import React, { useState, useEffect } from 'react';
import { Carousel, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { apiFetch, API_URL } from '../../utils/api.js';

import image_1 from '../../assets/images/1.jpg';
import image_2 from '../../assets/images/2.jpg';
import image_3 from '../../assets/images/3.jpg';

function Preview() {
  const [slides, setSlides] = useState([]);

  // Загружаем слайды из БД
  useEffect(() => {
    apiFetch('/api/slides')
      .then(res => res.json())
      .then(data => setSlides(data))
      .catch(() => {});
  }, []);

  // Качественный дефолтный контент
  const defaultSlides = [
    { 
      id: 'd1', 
      image: image_1, 
      title: "Строим с душой и на века", 
      text: "Профессиональная команда строителей для реализации ваших самых смелых идей." 
    },
    { 
      id: 'd2', 
      image: image_2, 
      title: "Идеальная укладка плитки", 
      text: "Используем лазерные уровни и лучшие смеси для безупречного результата." 
    },
    { 
      id: 'd3', 
      image: image_3, 
      title: "Земляные работы любой сложности", 
      text: "Собственный парк техники позволяет выполнять работы быстро и экономно." 
    }
  ];

  const finalSlides = slides.length > 0 ? slides : defaultSlides;

  return (
    <div className="hero-carousel">
      <Carousel fade indicators={true} controls={true} interval={3000} touch={true}>
        {finalSlides.map((slide) => (
          <Carousel.Item key={slide.id}>
            <img
              className="d-block w-100"
              src={String(slide.id).startsWith('d') ? slide.image : `${API_URL}/${slide.image}`}
              alt={slide.title}
            />
            <div className="hero-overlay">
              <Container>
                <div style={{ maxWidth: '700px' }}>
                  <h1 className="display-3 fw-bold text-white mb-4">
                    {slide.title}
                  </h1>
                  <p className="fs-4 text-white-50 mb-5">
                    {slide.text}
                  </p>
                  <Button as={Link} to="/catalog" className="btn-corp btn-lg">
                    Наши услуги
                  </Button>
                </div>
              </Container>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default Preview;
